import { Item, LinkItem } from '../../hub-components/universal-header/types'
import { SharedApolloClientBase, TypedApolloClientBase } from '../../types'
import { GetGiftCardsQuery } from './query'

export const getGiftCards = async (
  client: SharedApolloClientBase,
  country: string
): Promise<{
  giftCardNavLinks: LinkItem[]
  navigationMenu: Item[]
}> => {
  const { data } = await (client as TypedApolloClientBase).query({
    query: GetGiftCardsQuery,
    context: { version: 2 },
    variables: {
      country,
    },
  })

  if (!data?.cfContentPageCollection?.items?.[0]?.navigationMenu) {
    throw new Error('No data returned')
  }
  const navObject = data.cfContentPageCollection.items[0].navigationMenu

  return {
    giftCardNavLinks: navObject.featured,
    navigationMenu: navObject.nav,
  }
}
